import { IonButton, IonContent, IonToolbar } from '@ionic/react';
import ListItem from 'components/items/list-item/ListItem';
import SearchBar from 'components/searchbar/SearchBar';
import LoadingIonList from 'core/layout/loading-ion-list/LoadingIonList';
import MenuHeader from 'core/layout/menu-header/MenuHeader';
import {
  INVENTORY_COLORS_BREADCRUMB_LABEL,
  INVENTORY_OPTIONS_BREADCRUMB_LABEL
} from 'core/constants';
import React from 'react';
import ArrowRight from 'assets/icons/arrow-right.svg';
import HomeSelectionIcon from 'assets/icons/dashboard.svg';
import PaintIcon from 'assets/icons/paint.svg';
import { ProductGroup } from 'features/shared/inventory/store/InventorySlice';
import { iconForGroup } from 'features/shared/inventory/utils/inventoryGroupIcons';
import 'features/shared/inventory/InventoryGroups.scss';

interface InventoryGroupListViewMobileProps {
  loading: boolean;
  productGroups: ProductGroup[];
  search: string;
  onSearchChange: (val: string) => void;
  onAddItem: () => void;
  optionsCount: number;
  colorsCount: number;
  standardProductGroups: ProductGroup[];
  onShowGroup: (id: number) => void;
  onNavigateToHomeSelections: () => void;
  onNavigateToColorSelections: () => void;
  searchResultsView: React.ReactNode;
}

const InventoryGroupListViewMobile: React.FC<
  InventoryGroupListViewMobileProps
> = ({
  loading,
  productGroups,
  search,
  onSearchChange,
  onAddItem,
  optionsCount,
  colorsCount,
  standardProductGroups,
  onShowGroup,
  onNavigateToHomeSelections,
  onNavigateToColorSelections,
  searchResultsView
}) => {
  return (
    <>
      <MenuHeader title={'Inventory'} />
      <IonContent fullscreen>
        <SearchBar
          value={search}
          disabled={productGroups?.length === 0}
          debounce={1000}
          onSearchChange={onSearchChange}
        />
        <LoadingIonList
          label={'Items In Inventory'}
          description={'There are no items of this kind added yet.'}
          items={productGroups}
          loading={loading}
        >
          {!!search ? (
            searchResultsView
          ) : (
            <>
              {optionsCount > 0 ? (
                <ListItem
                  key="home-option-selections"
                  className="hk-inventory-home-selections-card"
                  startIcon={HomeSelectionIcon}
                  endIcon={ArrowRight}
                  title={INVENTORY_OPTIONS_BREADCRUMB_LABEL}
                  description={`${optionsCount} item(s)`}
                  onClick={onNavigateToHomeSelections}
                />
              ) : null}
              {colorsCount > 0 ? (
                <ListItem
                  key="home-color-selections"
                  className="hk-inventory-home-selections-card hk-inventory-color-selections-card"
                  startIcon={PaintIcon}
                  endIcon={ArrowRight}
                  title={INVENTORY_COLORS_BREADCRUMB_LABEL}
                  description={`${colorsCount} item(s)`}
                  onClick={onNavigateToColorSelections}
                />
              ) : null}
              {standardProductGroups.map((g, i) => {
                const { id, group, count } = g;
                return (
                  <ListItem
                    key={`item-${i}`}
                    startIcon={iconForGroup(id)}
                    endIcon={ArrowRight}
                    title={group}
                    description={count + ' item(s)'}
                    onClick={() => onShowGroup(id)}
                  />
                );
              })}
            </>
          )}
        </LoadingIonList>
      </IonContent>
      <IonToolbar className="hk-mobile-digital-inventory-groups-toolbar">
        <IonButton
          expand="block"
          color="primary"
          strong={true}
          onClick={onAddItem}
        >
          Add Item
        </IonButton>
      </IonToolbar>
    </>
  );
};

export default InventoryGroupListViewMobile;
